// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"163":"map","372":"client-only-ui"}[chunkId] + "." + {"163":"b1410c26b55cbc075571","372":"96f004b0eb3092ff7136"}[chunkId] + ".css";
};